// extracted by mini-css-extract-plugin
module.exports = {"row":"UploadCertificate_row__2sX8H","chooseFile":"UploadCertificate_chooseFile__GVyJl"};